// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  linkId: __t.u64().primaryKey().name("link_id"),
  twinId: __t.string().name("twin_id"),
  streamName: __t.string().name("stream_name"),
  dofName: __t.string().name("dof_name"),
  kind: __t.string(),
  inMin: __t.f64().name("in_min"),
  inMax: __t.f64().name("in_max"),
  outMin: __t.f64().name("out_min"),
  outMax: __t.f64().name("out_max"),
});
